// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610061826/js/" + chunkId + "." + {"44":"77aebd66","225":"f849f166","481":"e7526381","486":"bba0d129","770":"f4047295"}[chunkId] + ".0.25208194907717363.chunk.js";
};